import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAppSelector } from 'app/hooks';
import Lists from 'components/molecules/List/Lists';
import { CustomMenuItem } from 'components/organisms/Header/HomeHeader/styles';
import { selectAuth } from 'features/auth/authSlice';
import {
  Notification,
  NotificationType,
} from 'interfaces/Notification.interface';
// import Lists from 'components/molecules/List/Lists';
import * as React from 'react';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const Body = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  marginTop: '10px',
  paddingBottom: '100px',
  backgroundColor: '#292739',
  width: '100vw',
  gap: '20px',
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '38px',
  paddingRight: '38px',
}));

const ParaTextDivGrid = styled(ContentGrid)(({ theme }) => ({
  justifyContent: 'space-between',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
}));

const ParaText = styled(TitleText)(({ theme }) => ({
  fontSize: '18px',
}));

const NotificationBody = () => {
  const authState = useAppSelector(selectAuth);

  const getNotificationMessage = (notification: Notification) => {
    switch (notification.notificationType) {
      case NotificationType.LIKE:
        return `has liked your ${
          notification.backstage ? 'Backstage post' : 'NFT'
        }.`;
      case NotificationType.COMMENT:
        return `has commented on your ${
          notification.backstage ? 'Backstage post' : 'NFT'
        }.`;
      case NotificationType.CONTENT:
        return `has purchased your content.`;
      case NotificationType.FOLLOW:
        return `has followed you`;
      case NotificationType.SUBSCRIPTION:
        return `has subscribed to your content.`;
    }
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body container>
          <ParaTextDivGrid item xs={12}>
            <ParaText>today</ParaText>
          </ParaTextDivGrid> 
          <ContentGrid item xs={12}>
            {authState.notificationsReceived &&
            authState.notificationsReceived.length > 0 ? (
              authState.notificationsReceived.map((value, i) => {
                return (
                  <CustomMenuItem key={i}>
                    <Lists
                      key={value.id}
                      user={value.from}
                      time={'1h'}
                      image={
                        value.backstage?.images[0] || value.nft?.poster || ''
                      }
                      type={'first'}
                      message={getNotificationMessage(value)}
                    />
                  </CustomMenuItem>
                );
              })
            ) : (
              <CustomMenuItem sx={{ color: 'white' }}>
                No notifications available.
              </CustomMenuItem>
            )}
          </ContentGrid>
          {/* <ParaTextDivGrid item xs={12}>
            <ParaText>yesterday</ParaText>
          </ParaTextDivGrid> */}
          <ContentGrid item xs={12}>
            {/* {[0, 1, 2, 3, 4, 5, 6, 7].map((value) => (
              <Lists key={value} user={"@remind"} time={"1d"} image={"img" + value} type={"second"} message={" has subscribed to your page 0.02 ETH."} />
            ))} */}
          </ContentGrid>
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default NotificationBody;
